import cn from 'classnames';
import type { IntervalTypeV3 } from 'domains/products/products.types';
import React from 'react';

import { H3 } from '../../typography/Typography';
import type { CurrencyEnum } from '../FormattedPrice';
import { FormattedPrice } from '../FormattedPrice';

import styles from './styles.module.scss';

export const ProductMiniTitle: React.FC<{
  price: number | string;
  discount: number | string | null;
  discountPrice: number | string | null;
  currency: CurrencyEnum;
  interval?: IntervalTypeV3;
  isCurrent?: boolean;
}> = ({ price, discount, currency, interval, isCurrent, discountPrice }) => {
  let content = null;

  if (isCurrent) {
    content = (
      <H3 className={styles.monthPrice}>
        <div className={styles.paidInterval}>{interval}</div>
        <div className={styles.paidText}>Your current plan</div>
      </H3>
    );
  } else if (price && !discount) {
    content = (
      <H3 className={cn(styles.monthPrice, styles.center)}>
        <FormattedPrice price={price} currency={currency} /> / {interval}
      </H3>
    );
  } else if (price && discountPrice) {
    content = (
      <H3 className={styles.monthPrice}>
        <FormattedPrice price={discountPrice} currency={currency} /> /{' '}
        {interval}{' '}
        <span className={styles.oldPrice}>
          <FormattedPrice price={price} currency={currency} />
        </span>{' '}
      </H3>
    );
  }

  return <div className={styles.titleWrapper}>{content}</div>;
};

ProductMiniTitle.displayName = 'Payments/ProductMiniTitle';
